module.exports = __webpack_public_path__ + "img/album10_09.55a5d3c9.jpg";